import { render, staticRenderFns } from "./DriverAttributesForm.vue?vue&type=template&id=32c6b517&"
import script from "./DriverAttributesForm.vue?vue&type=script&lang=js&"
export * from "./DriverAttributesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32c6b517')) {
      api.createRecord('32c6b517', component.options)
    } else {
      api.reload('32c6b517', component.options)
    }
    module.hot.accept("./DriverAttributesForm.vue?vue&type=template&id=32c6b517&", function () {
      api.rerender('32c6b517', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Drivers/Forms/DriverAttributesForm.vue"
export default component.exports